import React, { useEffect, useMemo, useState } from "react";
import InputCopy from "../../../components/CopyComponent/InputCopy";
import { globalLink } from "../../../config";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import ReferWrap from "./ReferWrap";
import { HiChevronRight } from "react-icons/hi";
import { formatNumber } from "../../../utils/formatNumber";
import { REPLACE_AIR } from "../../../replace_str_constant";
import { useNavigate } from "react-router";
import { COMMON_WEB_PATH, CURRENCY_SYMBOL, WEB_PATH } from "../../../constant";
import LoadingIcon from "../../../components/Loading/LoadingIcon";
import ReferTitle from "./ReferTitle";
import ReferColumn from "./ReferColumn";
import RuleDetail from "./RuleDetail";
import { Button, Divider, Icon, Input } from "semantic-ui-react";
import { getCommissionList, getShortLink } from "../../../api/getApi";
import { withdrawCommission } from "../../../api/postApi";
import ComissionListPage from "./ComissionListPage";
import { openComissionListPop } from "../../../redux/action/member/memberAction";
import { notice } from "../../../redux/action/action";
import CommonConfirmModal from "../../../components/Modal/commonConfirmModal";
import QRCode, { QRCodeCanvas } from "qrcode.react";
import ReferQrcode from "./referQrcode";

const TabYourReferCode = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`referral.${key}`);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [withdrawLoading, setWithdrawLoading] = useState(false);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);

  const memberData = useSelector((state) => state.isMemberInfo);
  const comissionListPop = useSelector((state) => state.isComissionListPop);

  const [cagentCommissionList, setCagentCommissionList] = useState([]); //api回傳的代理傭金列表
  const [cagentCommissionInfo, setCagentCommissionInfo] = useState({
    selfChildCount: 0, //直屬會員
    allChildCount: 0, //搜尋底下會員
    lastWeekChildCount: 0, //上周新增
    thisWeekChildCount: 0, //本週新增
    lastMonthChildCount: 0, //上個月新增
    thisMonthChildCount: 0, //本個月新增
    totalWashSelfToday: 0, //日結自己統計
    totalWashChildToday: 0, //日結子統計
  }); //api回傳的代理傭金資訊
  const [commissionPoint, setCommissionPoint] = useState(0); //api回傳的代理傭金
  const [withdrawStatus, setWithdrawStatus] = useState(0);
  const [trigger, setTrigger] = useState(false);
  const [shortLink, setShortLink] = useState("");

  useEffect(() => {
    setIsLoading(true);
    getCommissionList() // 這是獲取傭金資訊的api
      .then((data) => {
        const { cagentInfo, cagentList, point, withdraw } = data;

        setCommissionPoint(point);
        setCagentCommissionList(cagentList);
        setCagentCommissionInfo(cagentInfo);
        setWithdrawStatus(withdraw);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [trigger]);

  useEffect(() => {
    getShortLink()
      .then((data) => {
        setShortLink(data?.short_url);
      })
      .catch((err) => {})
      .finally(() => {});
  }, []);

  const handleGetCommission = () => {
    setWithdrawLoading(true);
    withdrawCommission() //領傭金api
      .then((data) => {
        dispatch({ type: "GET_BALANCE" });
        dispatch(notice("Success", "success"));
        setOpenConfirmModal(false);
      })
      .catch((err) => {})
      .finally(() => {
        setWithdrawLoading(false);
        setTrigger(!trigger);
      });
  };

  const FRIENDS_LIST = [
    {
      label: "Total Register Friends",
      value: cagentCommissionInfo?.selfChildCount,
      // span: "col-span-3",
    },
    {
      label: "Direct Register Friends",
      value: cagentCommissionInfo?.allChildCount,
      // span: "col-span-2",
    },
  ];

  const TOTAL_TURNOVER = [
    {
      label: i18n("Your Turnover"),
      symbol: true,
      value: cagentCommissionInfo?.totalWashSelfToday,
      //span: "col-span-2",
    },
    // {
    //   label: i18n("Direct Turnover"),
    //   symbol: true,
    //   value: referDetail?.unlimit_total_thisweek?.selfbet,
    // },
    {
      label: i18n("Agent Turnover"),
      symbol: true,
      value: cagentCommissionInfo?.totalWashChildToday,
    },
  ];

  const REWARD_LIST = [
    {
      label: "ThisWeek Friends",
      value: cagentCommissionInfo?.thisWeekChildCount,
    },
    {
      label: "LastWeek Friends",
      value: cagentCommissionInfo?.lastWeekChildCount,
    },
    {
      label: "ThisMonth Friends",
      value: cagentCommissionInfo?.thisMonthChildCount,
    },
    {
      label: "LastMonth Friends",
      value: cagentCommissionInfo?.lastMonthChildCount,
    },
  ];

  return (
    <main className="flex flex-col gap-[10px]">
      <section className="flex flex-col gap-[10px]">
        <p className="mb-0 text-transaction-text dark:text-base-light-white font-medium text-lg">
          {i18n("Referrals")}
        </p>
        <span className="text-sm text-transaction-text dark:text-base-light-white">
          {i18n("Your")}
          {i18n("link")}
        </span>
        <InputCopy copyLink={shortLink} />
        <span className="text-sm text-transaction-text dark:text-base-light-white">
          {i18n("Your")}
          {i18n("code")}
        </span>
        <InputCopy copyLink={`${memberData?.memId}`} />
        <span className="text-base text-transaction-text dark:text-base-light-white text-center">
          {i18n("Your")}
          QRCode
        </span>
        <Divider className="!my-[5px]" />
        <div className="p-[7px] dark:bg-base-light-dark bg-base-light-white rounded-[5px] mx-auto">
          <a className="cursor-pointer" href={shortLink}>
            <ReferQrcode value={shortLink} />
          </a>
        </div>
      </section>
      <Divider />
      <section>
        <div className="flex items-center justify-between mb-[10px]">
          <p className="mb-0 text-transaction-text dark:text-base-light-white font-medium text-lg">
            {i18n("Now Withdraw Comission")}
          </p>
          <p className="font-semibold text-xl mb-0 text-transaction-text dark:text-base-light-white">
            {commissionPoint}
          </p>
        </div>

        <div className="flex items-center justify-between font-medium text-light-white">
          <p className="mb-0 text-gold-text">{i18n("notice.tip1")}</p>
          <Button
            className={`${
              withdrawStatus == 1 ? "!bg-gray-500" : "!bg-main-color"
            } !text-light-white font-bold custom-button`}
            size="tiny"
            loading={withdrawLoading}
            disabled={withdrawLoading || withdrawStatus == 1}
            onClick={() => {
              setOpenConfirmModal(true);
            }}
          >
            {withdrawStatus == 0 ? i18n("withdraw") : i18n("withdrawing")}
          </Button>
        </div>
      </section>

      <ReferWrap>
        <section className="grid grid-cols-1 w-full bg-second-color dark:bg-base-dark rounded-lg overflow-hidden">
          {FRIENDS_LIST.map((item, index) => {
            return (
              <div
                key={index}
                className={`p-[8px] rounded-[5px] flex items-center justify-between ${
                  index % 2 === 0 && "bg-base-white dark:bg-base-light-dark"
                } border-b border-second-color dark:border-base-dark ${
                  item.span && item.span
                }`}
              >
                <p className="mb-0 text-light-text font-semibold">
                  {i18n(item.label)}
                </p>
                <p className="font-bold">
                  <LoadingIcon commonLoading={isLoading}>
                    {item.value ?? 0}
                  </LoadingIcon>
                </p>
              </div>
            );
          })}
        </section>

        <section className="grid grid-cols-1 w-full bg-second-color dark:bg-base-dark rounded-lg overflow-hidden">
          {TOTAL_TURNOVER.map((item, index) => {
            return (
              <div
                key={index}
                className={`p-[8px] rounded-[5px] flex items-center justify-between ${
                  index % 2 === 0 ? "bg-base-white dark:bg-base-light-dark" : ""
                }`}
              >
                <p
                  className={`mb-0 text-light-text text-center font-semibold `}
                >
                  {item.label}
                </p>
                <p className="font-bold">
                  <LoadingIcon commonLoading={isLoading}>
                    {item.value}
                  </LoadingIcon>
                </p>
              </div>
            );
          })}
        </section>
        <section className="grid grid-cols-1 w-full mb-[10px] bg-second-color dark:bg-base-dark rounded-lg overflow-hidden">
          {REWARD_LIST.map((item, index) => {
            return (
              <div
                key={index}
                className={`p-[8px] rounded-[5px] flex items-center justify-between ${
                  index % 2 === 0 ? "bg-base-white dark:bg-base-light-dark" : ""
                }`}
              >
                <p
                  className={`mb-0 text-light-text text-center font-semibold `}
                >
                  {" "}
                  {i18n(item.label)}
                </p>
                <p className="font-bold">
                  <LoadingIcon commonLoading={isLoading}>
                    {item.value || 0}
                  </LoadingIcon>
                </p>
              </div>
            );
          })}
        </section>

        <div
          className={`py-[8px] px-[5px] flex flex-col text-sm font-semibold items-start justify-between col-span-2 rounded-lg bg-base-white dark:bg-base-light-dark mb-[10px]`}
        >
          <p className=" text-gold-text mb-[5px]">*{i18n("notice.tip2")}</p>
          <p className=" text-gold-text mb-[5px]">*{i18n("notice.tip3")}</p>
        </div>
        <section className="flex gap-[10px] mb-[10px] items-center">
          <Button
            className="!bg-main-color !text-light-white !w-full"
            onClick={() => {
              dispatch(openComissionListPop());
            }}
          >
            {i18n("comissionList")}
          </Button>
        </section>
      </ReferWrap>

      <section className="w-full flex flex-col gap-[10px]">
        <p className="mb-0 text-transaction-text dark:text-base-light-white font-medium text-lg">
          {" "}
          {i18n("rule")}
        </p>

        {/*規則表格*/}
        <section className="text-sm bg-input-color dark:bg-base-light-dark p-[16px] rounded-[10px] text-transaction-text">
          <p className="text-gold-text mb-[5px] font-semibold ">
            {i18n("warning.tip1")}
          </p>
          <p className="text-xs sm:text-sm mb-[5px] text-light-text leading-5">
            {i18n("warning.tip2")}
          </p>
          <p className="text-xs sm:text-sm mb-[5px] text-light-text leading-5">
            {i18n("warning.tip3")}
          </p>
          <p className="text-xs sm:text-sm mb-[5px] text-light-text leading-5">
            {i18n("warning.tip4")}
          </p>
          <p className="text-xs sm:text-sm mb-[5px] text-light-text leading-5">
            {i18n("warning.tip5")}
          </p>
        </section>
        <RuleDetail />
      </section>
      {comissionListPop && (
        <ComissionListPage cagentCommissionList={cagentCommissionList} />
      )}
      {openConfirmModal && (
        <CommonConfirmModal
          modalOpen={openConfirmModal}
          setModalOpen={setOpenConfirmModal}
          onConfirm={() => {
            handleGetCommission();
          }}
          size="mini"
          modalProps={{
            title: i18n("withdrawCommissionTitle"),
            content: i18n("withdrawCommissionContent"),
            cancelButtonText: i18n("cancelButtonText"),
            okButtonText: i18n("okButtonText"),
          }}
        />
      )}
    </main>
  );
};

export default TabYourReferCode;
